// CameraModal.jsx

import React, { useCallback } from 'react';

// Device Detection
import { useIsMobile } from 'hooks/useDeviceDetect';

// Components
import Camera from './Camera';
import Modal from 'components/modal/Modal';

/**
 * CameraModal
 *
 * Displays a modal containing the unified Camera component (Photo / Video).
 *
 * @param {boolean} isOpen - Whether the modal is open.
 * @param {function} setOpen - Function to set the open state.
 * @param {string} [contentType] - Optional initial mode: SNAPSHOT/PHOTO or RECORDING/VIDEO.
 * @param {function} onContentCreated - Callback when content is created.
 *
 * @returns {ReactNode} The rendered component.
 */
const CameraModal = ({
  isOpen,
  setOpen,
  contentType,
  onContentCreated,
}) => {

  // ----- DEVICE DETECTION ----- //

  const isMobile = useIsMobile();

  const modalWidth = isMobile ? '100%' : 800;
  const modalHeight = isMobile ? '100%' : 600;

  // ----- HANDLERS ----- //

  /**
   * Closes the camera modal.
   */

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  // ----- RENDER ----- //

  return (
    <Modal
      isOpen={isOpen}
      width={modalWidth}
      height={modalHeight}
      showHeader={false}
      enableClose={true}
      padding="0"
      onClose={handleClose}
    >
      <div
        style={{
          height: '100%',
          width: '100%',
        }}
      >
        <Camera
          contentType={contentType}
          onContentCreated={onContentCreated}
        />
      </div>
    </Modal>
  );
};

// Dev Tools
CameraModal.displayName = 'CameraModal';

export default CameraModal;
